import React from 'react';
import { createRoot } from 'react-dom/client';

import Informacion from './routes/Informacion';
import * as Llamadas from './Llamadas';
import { StrictMode } from 'react';

import './common/styles/index.scss';


class WebComponent extends HTMLElement {
	constructor() {
		super();
	}

	async connectedCallback() {
		let traducciones = await Llamadas.getTraducciones();
		let aeropuertos = await Llamadas.getAeropuertos();

		let listaAeropuertos = [];
		aeropuertos.items.forEach((aero) => {
			listaAeropuertos.push({
				id: aero.id,
				nombre: aero.nombre,
				responsableAeropuerto: aero.emailResponsable
			});
		});

		createRoot(this).render(
			<StrictMode>

				<Informacion
					listaAeropuertosAPI={listaAeropuertos}
					traducciones={traducciones}
				/>

			</StrictMode>,
			this
		);


	}
}

const ELEMENT_ID = 'spain-transfers-contacto';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
